<div class="px-4 pt-5 my-5 text-center border-bottom">
  <h1 class="display-4 fw-bold text-body-emphasis">Servicios</h1>
  <div class="col-lg-6 mx-auto">
    <p class="lead mb-4">A continuación, le presentamos la amplia gama de servicios que MediLink pone a disposición de todos sus usuarios. Nuestro compromiso es ofrecer soluciones integrales y de alta calidad para satisfacer sus necesidades de salud y bienestar.</p>
    <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
      <!--<button type="button" class="btn btn-primary btn-lg px-4 me-sm-3">Primary button</button>
      <button type="button" class="btn btn-outline-secondary btn-lg px-4">Secondary</button>-->
    </div>
  </div>
  <div class="overflow-hidden" style="max-height: 30vh;">
    <div class="container px-5">
      <img src="assets/img/farmacia.png" class="img-fluid border rounded-3 shadow-lg mb-4" alt="Example image" width="700" height="500" loading="lazy">
    </div>
  </div>
</div>
